import * as Rx from 'rxjs';
import * as RxOp from 'rxjs/operators';
import { searchForItem } from '../../utils/api/client';
import { getPosApiUrl, getAccessToken } from '../../utils/state';
import { replaceAlerts } from '../../components/alert-bar/AlertBar.state';

import {
  SEND_SEARCH_REQUEST,
  searchAlertBarAction,
  searchRequestSuccess,
  searchError,
} from './Search.state';

const onErrorEpic = ({ errorMessage }) =>
  Rx.of(
    searchError(errorMessage),
    searchAlertBarAction(
      replaceAlerts({
        heading: 'Search Failed',
        text: errorMessage,
        variant: 'error',
      }),
    ),
  );

const searchRequestParams = (state, payload) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
  id: payload.id,
  key: payload.key,
  value: payload.value,
});

export const searchForItemEpic = (action$, state$) =>
  action$.ofType(SEND_SEARCH_REQUEST).pipe(
    RxOp.flatMap((action) =>
      Rx.from(
        searchForItem(searchRequestParams(state$.value, action.payload)),
      ).pipe(
        RxOp.flatMap((response) => {
          if (!response.data.receivables.length) {
            return Rx.of(
              searchRequestSuccess(response.data),
              searchAlertBarAction(
                replaceAlerts({
                  heading: 'No Payment Available',
                  text: 'Your search was successful, but a payment is not available.',
                  variant: 'info',
                }),
              ),
            );
          } else {
            action.payload.navigate('/pos/results');
            return Rx.of(searchRequestSuccess(response.data));
          }
        }),
        RxOp.catchError((err) =>
          onErrorEpic({
            errorMessage: err.message,
          }),
        ),
      ),
    ),
  );
